<div
  [class]="'check-box-wrapper d-flex align-items-center justify-content-start gap-pony ' + wrapperCLasses()"
  [ngStyle]="{ width: size() + 'px', height: size() + 'px' }"
  (click)="itemClick()"
>
  @if (checked()) {
    <common-icon-dp-icon
      [classes]="'text-oninvert-high'"
      [iconSize]="size()"
      [icon]="'Check'"
      [iconType]="'linear'"
    ></common-icon-dp-icon>
  }
</div>
